// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.notifications {
  position: relative;
}
.notifications__button {
  min-width: 16px;
  display: flex;
  align-items: center;
  justify-content: center;
}
.notifications__flag {
  position: absolute;
  top: -8px;
  left: -5px;
  z-index: 1;
  width: 16px;
  height: 16px;
  border: 2px solid var(--sebrae-white);
  border-radius: 100%;
  background-color: var(--sebrae-red-2);
  color: var(--sebrae-white);
  font-size: 8px;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 1px;
  text-align: center;
}
.notifications__wrapper {
  position: absolute;
  z-index: 11;
  top: 32px;
  right: -50px;
  border-radius: 4px;
  background-color: var(--sebrae-white);
  width: 300px;
  max-height: 543px;
  border: 1px solid rgb(207, 226, 252);
  box-shadow: rgba(20, 46, 82, 0.2) 0 8px 12px 0;
  transform-origin: top;
  transform: scaleY(0);
  opacity: 0;
  transition: transform 255ms cubic-bezier(0.4, 0, 0.2, 1), opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.notifications__wrapper--content {
  width: 100%;
  height: 100%;
  opacity: 0;
  transition: opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);
  color: var(--sebrae-dark-gray3);
}
.notifications__wrapper--header {
  color: var(--sebrae-blue-6);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 12px;
}
.notifications__wrapper--header h6 {
  font-size: 19px;
  font-weight: 700;
  margin: 0;
}
.notifications__wrapper--body {
  position: relative;
  max-height: 388px;
  overflow-y: auto;
}
.notifications__wrapper--body ul {
  list-style: none;
  padding: 0;
}
.notifications__wrapper--body ul li {
  border-bottom: 1px solid var(--sebrae-light-gray4);
}
.notifications__wrapper--body ul li:last-of-type {
  border-bottom: none;
}
.notifications__wrapper--body .empty {
  padding: 12px;
  font-size: 11px;
  color: var(--sebrae-dark-gray-2);
}
.notifications__wrapper--body .wrapper-loading-small {
  width: 100%;
  height: 100%;
  min-height: 300px;
  position: relative;
}
.notifications__wrapper::before {
  content: "";
  display: block;
  transform: rotate(45deg) scale(1) translateY(0px);
  position: absolute;
  top: -7px;
  right: 50px;
  opacity: 0;
  height: 14px;
  width: 14px;
  background-color: var(--sebrae-white);
  border-width: 1px;
  border-style: solid;
  border-image: initial;
  pointer-events: none;
  border-radius: 3px 0 0 0;
  border-color: rgb(207, 226, 252) transparent transparent rgb(207, 226, 252);
  transition: opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);
}
.notifications__wrapper.opened {
  transform: scaleY(1);
  opacity: 1;
}
.notifications__wrapper.opened .notifications__wrapper--content {
  opacity: 1;
}
.notifications__wrapper.opened::before {
  opacity: 1;
}
.notifications__btn-close {
  width: 8px;
  height: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--sebrae-blue-6);
}
.notifications__card {
  width: 100%;
  padding: 12px;
  display: flex;
  gap: 8px;
  min-height: 75px;
}
.notifications__card--avatar {
  position: relative;
}
.notifications__card--avatar .notifications__flag {
  top: -7px;
  left: -3px;
}
.notifications__card--user {
  font-size: 13px;
  font-weight: 700;
  margin-bottom: 6px;
  color: var(--sebrae-gray);
}
.notifications__card--text {
  font-size: 11px;
  color: var(--sebrae-dark-gray-2);
  margin-bottom: 4px;
  line-height: 1.1;
}
.notifications__card--text strong {
  color: var(--sebrae-blue-6);
}
.notifications__card--text span {
  color: var(--sebrae-black);
  opacity: 0.56;
}
.notifications__card--text.accepted {
  color: var(--sebrae-green);
}
.notifications__card--text.rejected {
  color: var(--sebrae-red-2);
}
.notifications__card--text:last-of-type {
  margin-bottom: 0;
}
.notifications__card--buttons {
  display: flex;
  gap: 9px;
  margin-top: 10px;
}
.notifications__card--buttons .btn-white-outline {
  border: 1px solid var(--sebrae-blue-6);
}
.notifications__card--buttons button {
  min-height: 32px;
  height: 32px;
  padding: 5px 8px;
  font-weight: 400;
  font-size: 13px !important;
}
.notifications__card--buttons button span {
  font: inherit;
}
.notifications__card--select {
  margin-top: 10px;
}
.notifications__card--select .input-select-container {
  width: 100%;
}
.notifications__card--select .input-select-title {
  font-size: 11px;
  margin-bottom: 6px;
  color: var(--sebrae-dark-gray-2);
}
@media screen and (min-width: 768px) {
  .notifications__wrapper {
    width: 440px;
  }
  .notifications__wrapper--header {
    padding: 16px 28px 8px 24px;
  }
  .notifications__wrapper .empty {
    padding: 16px 24px;
  }
  .notifications__card {
    padding: 16px 24px;
    min-height: 90px;
    gap: 16px;
  }
  .notifications__card--avatar .acronyms {
    min-width: 38px;
    width: 38px;
    height: 38px;
  }
  .notifications__card--avatar .notifications__flag {
    top: -4px;
    left: -2px;
  }
  .notifications__card--user {
    font-size: 16px;
    margin-bottom: 7px;
  }
  .notifications__card--text {
    font-size: 13px;
    margin-bottom: 5px;
  }
  .notifications__card--select {
    position: relative;
  }
  .notifications__card--select .input-select--inline-options .input-select__options {
    position: static;
  }
  .notifications__card--select .input-select-title {
    font-size: 13px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/notifications/index.scss"],"names":[],"mappings":"AAAA;EACE,kBAAA;AACF;AACE;EACE,eAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AACJ;AACE;EACE,kBAAA;EACA,SAAA;EACA,UAAA;EACA,UAAA;EACA,WAAA;EACA,YAAA;EACA,qCAAA;EACA,mBAAA;EACA,qCAAA;EACA,0BAAA;EACA,cAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,YAAA;EACA,kBAAA;AACJ;AACE;EACE,kBAAA;EACA,WAAA;EACA,SAAA;EACA,YAAA;EACA,kBAAA;EACA,qCAAA;EACA,YAAA;EACA,iBAAA;EACA,oCAAA;EACA,8CAAA;EACA,qBAAA;EACA,oBAAA;EACA,UAAA;EACA,oGAAA;AACJ;AAEI;EACE,WAAA;EACA,YAAA;EACA,UAAA;EACA,sDAAA;EACA,+BAAA;AAAN;AAEI;EACE,2BAAA;EACA,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,SAAA;EACA,aAAA;AAAN;AAEM;EAEI,eAAA;EACA,gBAAA;EAEF,SAAA;AAFR;AAKI;EACE,kBAAA;EACA,iBAAA;EACA,gBAAA;AAHN;AAKM;EACE,gBAAA;EACA,UAAA;AAHR;AAKQ;EACE,kDAAA;AAHV;AAKU;EACE,mBAAA;AAHZ;AAOM;EACE,aAAA;EACA,eAAA;EACA,gCAAA;AALR;AAOM;EACE,WAAA;EACA,YAAA;EACA,iBAAA;EACA,kBAAA;AALR;AASI;EACE,WAAA;EACA,cAAA;EACA,iDAAA;EACA,kBAAA;EACA,SAAA;EACA,WAAA;EACA,UAAA;EACA,YAAA;EACA,WAAA;EACA,qCAAA;EACA,iBAAA;EACA,mBAAA;EACA,qBAAA;EACA,oBAAA;EACA,wBAAA;EACA,2EAAA;EACA,sDAAA;AAPN;AASI;EACE,oBAAA;EACA,UAAA;AAPN;AASM;EACE,UAAA;AAPR;AASM;EACE,UAAA;AAPR;AAWE;EACE,UAAA;EACA,WAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,2BAAA;AATJ;AAWE;EACE,WAAA;EACA,aAAA;EACA,aAAA;EACA,QAAA;EACA,gBAAA;AATJ;AAWI;EACE,kBAAA;AATN;AAWM;EACE,SAAA;EACA,UAAA;AATR;AAYI;EAEI,eAAA;EACA,gBAAA;EAEF,kBAAA;EACA,yBAAA;AAZN;AAcI;EACE,eAAA;EACA,gCAAA;EACA,kBAAA;EACA,gBAAA;AAZN;AAcM;EACE,2BAAA;AAZR;AAcM;EACE,0BAAA;EACA,aAAA;AAZR;AAeM;EACE,0BAAA;AAbR;AAeM;EACE,0BAAA;AAbR;AAgBM;EACE,gBAAA;AAdR;AAiBI;EACE,aAAA;EACA,QAAA;EACA,gBAAA;AAfN;AAiBM;EACE,sCAAA;AAfR;AAiBM;EACE,gBAAA;EACA,YAAA;EACA,gBAAA;EAEE,gBAAA;EACA,0BAAA;AAhBV;AAmBQ;EACE,aAAA;AAjBV;AAqBI;EACE,gBAAA;AAnBN;AAqBM;EACE,WAAA;AAnBR;AAsBM;EACE,eAAA;EACA,kBAAA;EACA,gCAAA;AApBR;AAyBE;EACE;IACE,YAAA;EAvBJ;EAyBI;IACE,2BAAA;EAvBN;EAyBI;IACE,kBAAA;EAvBN;EA0BE;IACE,kBAAA;IACA,gBAAA;IACA,SAAA;EAxBJ;EA2BM;IACE,eAAA;IACA,WAAA;IACA,YAAA;EAzBR;EA2BM;IACE,SAAA;IACA,UAAA;EAzBR;EA4BI;IACE,eAAA;IACA,kBAAA;EA1BN;EA4BI;IACE,eAAA;IACA,kBAAA;EA1BN;EA4BI;IACE,kBAAA;EA1BN;EA6BQ;IACE,gBAAA;EA3BV;EAgCM;IACE,eAAA;EA9BR;AACF","sourcesContent":[".notifications {\n  position: relative;\n\n  &__button {\n    min-width: 16px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n  &__flag {\n    position: absolute;\n    top: -8px;\n    left: -5px;\n    z-index: 1;\n    width: 16px;\n    height: 16px;\n    border: 2px solid var(--sebrae-white);\n    border-radius: 100%;\n    background-color: var(--sebrae-red-2);\n    color: var(--sebrae-white);\n    font-size: 8px;\n    font-weight: 400;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 1px;\n    text-align: center;\n  }\n  &__wrapper {\n    position: absolute;\n    z-index: 11;\n    top: 32px;\n    right: -50px;\n    border-radius: 4px;\n    background-color: var(--sebrae-white);\n    width: 300px;\n    max-height: 543px;\n    border: 1px solid rgb(207, 226, 252);\n    box-shadow: rgba(20, 46, 82, 0.2) 0 8px 12px 0;\n    transform-origin: top;\n    transform: scaleY(0);\n    opacity: 0;\n    transition: transform 255ms cubic-bezier(0.4, 0, 0.2, 1),\n    opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);\n\n    &--content {\n      width: 100%;\n      height: 100%;\n      opacity: 0;\n      transition: opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);\n      color: var(--sebrae-dark-gray3);\n    }\n    &--header {\n      color: var(--sebrae-blue-6);\n      display: flex;\n      align-items: center;\n      justify-content: space-between;\n      gap: 16px;\n      padding: 12px;\n\n      h6 {\n        font: {\n          size: 19px;\n          weight: 700;\n        }\n        margin: 0;\n      }\n    }\n    &--body {\n      position: relative;\n      max-height: 388px;\n      overflow-y: auto;\n\n      ul {\n        list-style: none;\n        padding: 0;\n\n        li {\n          border-bottom: 1px solid var(--sebrae-light-gray4);\n\n          &:last-of-type {\n            border-bottom: none;\n          }\n        }\n      }\n      .empty {\n        padding: 12px;\n        font-size: 11px;\n        color: var(--sebrae-dark-gray-2);\n      }\n      .wrapper-loading-small {\n        width: 100%;\n        height: 100%;\n        min-height: 300px;\n        position: relative;\n      }\n    }\n\n    &::before {\n      content: \"\";\n      display: block;\n      transform: rotate(45deg) scale(1) translateY(0px);\n      position: absolute;\n      top: -7px;\n      right: 50px;\n      opacity: 0;\n      height: 14px;\n      width: 14px;\n      background-color: var(--sebrae-white);\n      border-width: 1px;\n      border-style: solid;\n      border-image: initial;\n      pointer-events: none;\n      border-radius: 3px 0 0 0;\n      border-color: rgb(207, 226, 252) transparent transparent rgb(207, 226, 252);\n      transition: opacity 255ms cubic-bezier(0.4, 0, 0.2, 1);\n    }\n    &.opened {\n      transform: scaleY(1);\n      opacity: 1;\n\n      .notifications__wrapper--content {\n        opacity: 1;\n      }\n      &::before {\n        opacity: 1;\n      }\n    }\n  }\n  &__btn-close {\n    width: 8px;\n    height: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--sebrae-blue-6);\n  }\n  &__card {\n    width: 100%;\n    padding: 12px;\n    display: flex;\n    gap: 8px;\n    min-height: 75px;\n\n    &--avatar {\n      position: relative;\n\n      .notifications__flag {\n        top: -7px;\n        left: -3px;\n      }\n    }\n    &--user {\n      font: {\n        size: 13px;\n        weight: 700;\n      }\n      margin-bottom: 6px;\n      color: var(--sebrae-gray);\n    }\n    &--text {\n      font-size: 11px;\n      color: var(--sebrae-dark-gray-2);\n      margin-bottom: 4px;\n      line-height: 1.1;\n\n      strong {\n        color: var(--sebrae-blue-6);\n      }\n      span {\n        color: var(--sebrae-black);\n        opacity: 0.56;\n      }\n\n      &.accepted {\n        color: var(--sebrae-green);\n      }\n      &.rejected {\n        color: var(--sebrae-red-2);\n      }\n\n      &:last-of-type {\n        margin-bottom: 0;\n      }\n    }\n    &--buttons {\n      display: flex;\n      gap: 9px;\n      margin-top: 10px;\n\n      .btn-white-outline {\n        border: 1px solid var(--sebrae-blue-6);\n      }\n      button {\n        min-height: 32px;\n        height: 32px;\n        padding: 5px 8px;\n        font: {\n          weight: 400;\n          size: 13px!important;\n        }\n\n        span {\n          font: inherit;\n        }\n      }\n    }\n    &--select {\n      margin-top: 10px;\n\n      .input-select-container {\n        width: 100%;\n      }\n\n      .input-select-title {\n        font-size: 11px;\n        margin-bottom: 6px;\n        color: var(--sebrae-dark-gray-2);\n      }\n    }\n  }\n\n  @media screen and (min-width: 768px) {\n    &__wrapper {\n      width: 440px;\n\n      &--header {\n        padding: 16px 28px 8px 24px;\n      }\n      .empty {\n        padding: 16px 24px;\n      }\n    }\n    &__card {\n      padding: 16px 24px;\n      min-height: 90px;\n      gap: 16px;\n\n      &--avatar {\n        .acronyms {\n          min-width: 38px;\n          width: 38px;\n          height: 38px;\n        }\n        .notifications__flag {\n          top: -4px;\n          left: -2px;\n        }\n      }\n      &--user {\n        font-size: 16px;\n        margin-bottom: 7px;\n      }\n      &--text {\n        font-size: 13px;\n        margin-bottom: 5px;\n      }\n      &--select {\n        position: relative;\n\n        .input-select--inline-options {\n          .input-select__options {\n            position: static;\n            // border-top: 1px solid var(--sebrae-light-gray5);\n          }\n        }\n\n        .input-select-title {\n          font-size: 13px;\n        }\n      }\n    }\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
